<template>
  <div>
    <div class="pl-4 py-3">{{ title }}</div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data(){
    return {
     
    }
  },
  props: {
    title:{
      type: String
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
